import React, { useMemo } from "react";
import { Box, Flex, HStack, IconButton, Text, Button } from "@chakra-ui/react";
import { IoOpen } from "react-icons/io5";

export type PdfViewerProps = {
  url: string;
  className?: string;
  /** Omit outer chrome (title + open button); parent supplies layout and actions */
  embedded?: boolean;
};

export default function PdfViewer({ url, className, embedded = false }: PdfViewerProps) {
  const proxyUrl = url;

  return (
    <Box
      className={className}
      bg="white"
      borderRadius={embedded ? "none" : "lg"}
      boxShadow={embedded ? "none" : "lg"}
      overflow="hidden"
      display="flex"
      flexDirection="column"
      h={embedded ? "100%" : undefined}
      minH={embedded ? 0 : undefined}
      flex={embedded ? 1 : undefined}
      w="100%"
    >
      {!embedded && (
        <Flex
          px={2}
          py={2}
          align="center"
          justify="space-between"
          borderBottom="1px solid"
          borderColor="gray.200"
          bg="white"
          flexShrink={0}
        >
          <HStack spacing={2}>
            <Text fontSize="sm" fontWeight="semibold" color="gray.700">
              PDF
            </Text>
          </HStack>
          <HStack spacing={2}>
            <IconButton
              aria-label="PDF in neuem Tab öffnen"
              icon={<IoOpen />}
              size="sm"
              variant="outline"
              as="a"
              href={proxyUrl}
              target="_blank"
              rel="noreferrer"
            />
          </HStack>
        </Flex>
      )}

      {/* Important: container must be able to shrink; object uses 100% height */}
      <Box flex="1" height="100%" minH={0}>
        <object data={proxyUrl} type="application/pdf" style={{ width: "100%", height: "100%" }}>
          <Box p={4}>
            <Text fontSize="sm" color="gray.700" fontWeight="semibold">
              PDF not loading
            </Text>
            <Text mt={2} fontSize="sm" color="gray.600">
              Öffne die PDF alternativ in einem neuen Tab:
            </Text>
            <Button
              mt={3}
              size="sm"
              variant="outline"
              as="a"
              href={proxyUrl}
              target="_blank"
              rel="noreferrer"
              leftIcon={<IoOpen />}
            >
              PDF öffnen
            </Button>
          </Box>
        </object>
      </Box>
    </Box>
  );
}


